/**
 * Loading Screen Component
 */
import React from 'react';
import { Loader2 } from 'lucide-react';
import { BRAND } from '../config';

const LoadingScreen = () => (
  <div className="min-h-screen bg-[#1A1A1A] flex items-center justify-center">
    <div className="text-center">
      <img src={BRAND.logo} alt={BRAND.name} className="w-20 h-20 mx-auto mb-4 rounded-2xl object-contain" />
      <Loader2 className="w-6 h-6 text-[#F5A623] animate-spin mx-auto mb-3" />
      <p className="text-gray-500 text-sm">Caricamento...</p>
    </div>
  </div>
);

export default LoadingScreen;
